module.exports = __webpack_public_path__ + "img/message.d13888e2.webp";